import React from 'react';
import { Linkedin, ArrowUpRight } from 'lucide-react';

export const Team = () => {
  const team = [
    {
      name: 'Mahima Arora',
      role: 'CEO & Co-founder',
      highlights: [
        'Core Team, Microsoft OneNote - Built scalable Android app with 5M+ MAU',
        'Ex-Founding Member, Climate-tech Startup - Drove 5x revenue growth',
        'IIT Kanpur',
      ],
      linkedin: 'https://www.linkedin.com/in/mahima246',
      image: 'https://customer-assets.emergentagent.com/job_zailens-ai-testing/artifacts/c3hejcwp_Screenshot%202025-11-12%20at%202.58.22%E2%80%AFPM.png',
    },
    {
      name: 'Yatish Goel',
      role: 'CTO & Co-founder',
      highlights: [
        'Founding Engineer #1, US AI Startup - Built AI service desk for Fortune 500',
        'Open-Source Contributor - Key contributor to Storybook (88K+ GitHub stars)',
        'IIT Kanpur',
      ],
      linkedin: 'https://www.linkedin.com/in/yatish-goel-a29737228/',
      image: 'https://customer-assets.emergentagent.com/job_zailens-ai-testing/artifacts/of39y4as_Screenshot%202025-11-12%20at%202.58.06%E2%80%AFPM.png',
    },
  ];

  return (
    <section id="team" className="relative">
      <div className="section-divider"></div>

      <div className="container mx-auto px-6 py-28">
        <div className="max-w-5xl mx-auto">
          {/* Section header */}
          <div className="mb-16">
            <div className="tag mb-8">
              <span className="w-[6px] h-[6px] rounded-full bg-[#00ffd5] shadow-[0_0_8px_#00ffd5]"></span>
              Team
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
              Built by Engineers
              <br />
              <span className="text-white/30">Who've Scaled</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {team.map((member, index) => (
              <div
                key={index}
                className="card-tactical rounded-sm overflow-hidden group"
              >
                {/* Top bar */}
                <div className="flex items-center justify-between px-6 py-3 border-b border-white/[0.04] bg-white/[0.01]">
                  <span className="font-mono text-[0.6rem] text-white/30 tracking-wider uppercase">
                    PROFILE_{String(index + 1).padStart(2, '0')}
                  </span>
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1.5 font-mono text-[0.6rem] text-white/40 hover:text-[#00ffd5] transition-colors tracking-wider"
                  >
                    <Linkedin className="w-3 h-3" />
                    <ArrowUpRight className="w-2.5 h-2.5" />
                  </a>
                </div>

                <div className="p-7">
                  <div className="flex items-start gap-5 mb-6">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-16 h-16 object-cover border border-white/[0.06] grayscale group-hover:grayscale-0 transition-all duration-500"
                    />
                    <div>
                      <h3 className="text-xl font-bold text-white mb-0.5">
                        {member.name}
                      </h3>
                      <p className="font-mono text-[0.7rem] text-[#00ffd5]/60 tracking-wider">{member.role}</p>
                    </div>
                  </div>

                  <div className="space-y-3">
                    {member.highlights.map((highlight, i) => (
                      <div
                        key={i}
                        className="flex items-start gap-3 text-sm text-white/30 leading-relaxed"
                        style={{ fontFamily: 'var(--font-body)' }}
                      >
                        <span className="text-[#00ffd5]/40 font-mono text-xs mt-0.5">//</span>
                        {highlight}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
